export default __webpack_public_path__ + "static/media/index.d.f0e67823.ts";